(function () {
  var root = document.querySelector('.fk-checkout');
  var modal = document.getElementById('fk-modal');
  if (!root || !modal) return;

  var rawUrl = (root.getAttribute('data-redirect-url') || 'https://pulsetto.tech').trim();
  // Guard against an empty/invalid setting.
  var redirectUrl = /^https?:\/\//i.test(rawUrl) ? rawUrl : 'https://pulsetto.tech';

  var seconds = parseInt(root.getAttribute('data-redirect-seconds'), 10);
  if (isNaN(seconds) || seconds < 1) seconds = 10;

  var secondsEl = document.getElementById('fk-modal-seconds');
  var ctaEl = document.getElementById('fk-modal-cta');
  if (ctaEl) ctaEl.setAttribute('href', redirectUrl);

  // In the Shopify theme editor (design mode) the preview is sandboxed and we
  // must NOT redirect — otherwise the merchant gets bounced out and can never
  // configure the section. Redirects only run on the live storefront / previews.
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  var redirected = false;
  function go() {
    if (redirected || designMode) return;
    redirected = true;
    window.location.href = redirectUrl;
  }

  // Lock the page behind the modal.
  document.body.classList.add('fk-modal-open');

  // The modal cannot be dismissed: swallow Escape and keep focus trapped on the CTA.
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  // Backdrop clicks do nothing (no close handler is attached) — but stop them
  // from reaching anything underneath.
  var backdrop = modal.querySelector('.fk-modal__backdrop');
  if (backdrop) {
    backdrop.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  // CTA: redirect immediately.
  if (ctaEl) {
    ctaEl.addEventListener('click', function (e) {
      e.preventDefault();
      go();
    });
  }

  // Countdown → auto-redirect (only when enabled in the section settings).
  var autoRedirect = root.getAttribute('data-auto-redirect') !== 'false';

  function tick() {
    seconds -= 1;
    if (secondsEl) secondsEl.textContent = String(Math.max(seconds, 0));
    if (seconds <= 0) {
      go();
      return;
    }
    window.setTimeout(tick, 1000);
  }

  if (autoRedirect && !designMode) {
    if (secondsEl) secondsEl.textContent = String(seconds);
    window.setTimeout(tick, 1000);
  }

  // Keep focus on the dialog so keyboard users can't tab into the blocked form.
  if (ctaEl) {
    try {
      ctaEl.focus({ preventScroll: true });
    } catch (err) {
      ctaEl.focus();
    }
  }
})();
